module.exports = "images/transport_taxi.ecdad16516b27b004a38bb0d1512374f.png";